import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_xnabf4qzgp: FaireCollectionEntity = {
  token: "pbc_xnabf4qzgp",
  type: "collection",
  name: "Bonbon Blankets, Toys & Gift Sets",
  heroImageUrl:
    "https://cdn.faire.com/fastly/951f4ea5639e0128f84cc005c209a9278e9e7a7c52e74dddd87ca389031fe556.png",
  itemCount: 14,
  description:
    "A sweet assortment of organic cotton blankets, heirloom-quality toys, and curated gift sets designed for thoughtful gifting and everyday comfort. Ethically made in India using small-grower organic cotton, each piece support better livelihoods for farming communities.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:18.825Z",
    importedBy: "entity-db-import-collections",
  },
};
